const ROW_SELECTOR = '.js-conversation-row';
const MENU_SELECTOR = '#conversation-context-menu';
const BAR_SELECTOR = '#conversation-bulk-bar';
const DELETE_MODAL_SELECTOR = '#cockpit-delete-conversation-modal';

const selected = new Map();
let contextRow = null;
let pendingDelete = [];
let touchTimer = null;
let touchStart = null;
let suppressClickUntil = 0;
let deleteRedirectTimer = null;

function descriptorFromRow($row) {
    const type = String($row.data('conversation-type') || '');
    const descriptor = {
        type,
        unread: Number($row.data('conversation-unread') || 0),
        spam: String($row.data('conversation-spam')) === '1',
    };

    if (type === 'contact') {
        descriptor.key = String($row.data('conversation-key') || '');
    } else {
        descriptor.id = Number($row.data('conversation-id') || 0);
    }

    return descriptor;
}

function descriptorKey(descriptor) {
    return descriptor.type === 'contact'
        ? descriptor.type + ':' + descriptor.key
        : descriptor.type + ':' + descriptor.id;
}

function requestDescriptor(descriptor) {
    return descriptor.type === 'contact'
        ? { type: descriptor.type, key: descriptor.key }
        : { type: descriptor.type, id: descriptor.id };
}

function rowKey($row) {
    return descriptorKey(descriptorFromRow($row));
}

function hideMenu() {
    $(MENU_SELECTOR)
        .addClass('d-none')
        .removeClass('d-flex')
        .attr('aria-hidden', 'true');
    contextRow = null;
}

function renderSelection() {
    const hasSelection = selected.size > 0;
    $('body').toggleClass('conversation-selection-active', hasSelection);

    $(ROW_SELECTOR).each(function () {
        const $row = $(this);
        const isSelected = selected.has(rowKey($row));
        $row.toggleClass('is-conversation-selected', isSelected)
            .attr('aria-selected', isSelected ? 'true' : 'false');
        this.style.removeProperty('padding-left');
    });

    const $bar = $(BAR_SELECTOR);
    $bar.toggleClass('d-none', !hasSelection)
        .attr('aria-hidden', hasSelection ? 'false' : 'true');
    $bar.find('.conversation-bulk-count').text(
        selected.size + (selected.size === 1 ? ' selected' : ' selected')
    );

    const values = Array.from(selected.values());
    $bar.find('[data-conversation-action="read"]')
        .prop('disabled', !values.some(item => item.unread > 0));
    $bar.find('[data-conversation-action="spam"]')
        .prop('disabled', values.length === 0 || values.every(item => item.spam));
}

function toggleRow($row, forceSelected = null) {
    const descriptor = descriptorFromRow($row);
    const key = descriptorKey(descriptor);
    const shouldSelect = forceSelected === null ? !selected.has(key) : forceSelected;

    if (shouldSelect) {
        selected.set(key, descriptor);
    } else {
        selected.delete(key);
    }

    renderSelection();
}

function clearSelection() {
    selected.clear();
    renderSelection();
}

function openMenu($row, clientX, clientY) {
    const $menu = $(MENU_SELECTOR);
    if (!$menu.length) {
        return;
    }

    contextRow = $row;
    const descriptor = descriptorFromRow($row);
    const alreadySelected = selected.has(descriptorKey(descriptor));

    $menu.find('.js-conversation-context-select .conversation-action-label')
        .text(alreadySelected ? 'Remove from selection' : 'Select');
    $menu.find('.js-conversation-context-read')
        .toggleClass('d-none', descriptor.unread < 1);
    $menu.find('.js-conversation-context-spam')
        .prop('disabled', descriptor.spam)
        .attr('aria-disabled', descriptor.spam ? 'true' : 'false')
        .find('.conversation-action-label')
        .text(descriptor.spam ? 'Already marked as spam' : 'Mark as spam');

    $menu.removeClass('d-none')
        .addClass('d-flex')
        .attr('aria-hidden', 'false');

    const bounds = $menu[0].getBoundingClientRect();
    const left = Math.max(8, Math.min(clientX, window.innerWidth - bounds.width - 8));
    const top = Math.max(8, Math.min(clientY, window.innerHeight - bounds.height - 8));
    $menu.css({ left: left + 'px', top: top + 'px' });
    $menu.find('button:visible:not(:disabled)').first().trigger('focus');
}

function selectedDescriptors() {
    return Array.from(selected.values());
}

function resetDeleteFeedback() {
    if (deleteRedirectTimer) {
        window.clearTimeout(deleteRedirectTimer);
        deleteRedirectTimer = null;
    }

    const $modal = $(DELETE_MODAL_SELECTOR);
    const $button = $modal.find('.js-confirm-conversation-delete');

    $button
        .removeClass('is-loading is-success is-error')
        .text($button.data('default-label') || 'Delete');
    $modal.find('.conversation-delete-feedback')
        .removeClass('is-visible is-success is-error');
    $modal.find('.conversation-delete-feedback__text').text('');
    $modal.find('.bb-action-feedback__icon').text('');
}

function showDeleteFeedback(state, message) {
    const $modal = $(DELETE_MODAL_SELECTOR);
    const $button = $modal.find('.js-confirm-conversation-delete');
    const isSuccess = state === 'success';

    $button
        .removeClass('is-loading is-success is-error')
        .addClass(isSuccess ? 'is-success' : 'is-error')
        .text(isSuccess ? 'Deleted' : ($button.data('default-label') || 'Delete'));
    $modal.find('.conversation-delete-feedback')
        .removeClass('is-success is-error')
        .addClass('is-visible ' + (isSuccess ? 'is-success' : 'is-error'));
    $modal.find('.bb-action-feedback__icon').text(isSuccess ? '\u2713' : '!');
    $modal.find('.conversation-delete-feedback__text').text(message);
}

function setBusy(isBusy) {
    $(BAR_SELECTOR).toggleClass('is-busy', isBusy)
        .find('button')
        .prop('disabled', isBusy);
    $(MENU_SELECTOR).find('button').prop('disabled', isBusy);
    $(DELETE_MODAL_SELECTOR).find('.conversation-delete-actions .bb-btn')
        .prop('disabled', isBusy);
    $(DELETE_MODAL_SELECTOR).find('.js-confirm-conversation-delete')
        .toggleClass('is-loading', isBusy);
}

function showError(message) {
    const $error = $(BAR_SELECTOR).find('.conversation-bulk-error');
    $error.text(message || 'We could not update those conversations. Please try again.')
        .removeClass('d-none');
    setBusy(false);
    renderSelection();
}

function runAction(action, descriptors) {
    if (!descriptors.length) {
        return;
    }

    setBusy(true);
    $(BAR_SELECTOR).find('.conversation-bulk-error').addClass('d-none').text('');

    $.ajax({
        type: 'POST',
        url: '/cockpit/org-conversation-action',
        data: {
            action,
            conversations: descriptors.map(requestDescriptor),
        },
        success: function () {
            if (action === 'delete' && $(DELETE_MODAL_SELECTOR).hasClass('show')) {
                const successMessage = descriptors.length === 1
                    ? 'Conversation deleted successfully.'
                    : descriptors.length + ' conversations deleted successfully.';

                setBusy(false);
                showDeleteFeedback('success', successMessage);
                $(DELETE_MODAL_SELECTOR).find('.conversation-delete-actions .bb-btn')
                    .prop('disabled', true);
                deleteRedirectTimer = window.setTimeout(function () {
                    window.location.assign('/cockpit');
                }, 850);
                return;
            }

            window.location.assign('/cockpit');
        },
        error: function (xhr) {
            if (action === 'delete' && $(DELETE_MODAL_SELECTOR).hasClass('show')) {
                setBusy(false);
                showDeleteFeedback(
                    'error',
                    xhr.responseJSON?.message || 'Conversation could not be deleted. Please try again.'
                );
                return;
            }

            $(DELETE_MODAL_SELECTOR).modal('hide');
            showError(xhr.responseJSON?.message);
        },
    });
}

function openDeleteModal(descriptors) {
    pendingDelete = descriptors;
    const count = descriptors.length;
    const $modal = $(DELETE_MODAL_SELECTOR);

    resetDeleteFeedback();
    $modal.find('.modal-custom-title')
        .text(count === 1 ? 'Delete conversation?' : 'Delete conversations?');
    $modal.find('.conversation-delete-count')
        .text(count === 1 ? '1 conversation selected' : count + ' conversations selected');
    $modal.find('.conversation-delete-copy')
        .text(count === 1
            ? 'This removes every message in this conversation. This cannot be undone.'
            : 'This removes every message in the selected conversations. This cannot be undone.');
    $modal.modal('show');
}

function contextDescriptors() {
    return contextRow ? [descriptorFromRow(contextRow)] : [];
}

function cancelTouchTimer() {
    if (touchTimer) {
        window.clearTimeout(touchTimer);
        touchTimer = null;
    }
    touchStart = null;
}

function bindTouchMenu() {
    $('body').on('touchstart', ROW_SELECTOR, function (event) {
        const touch = event.originalEvent.touches?.[0];
        if (!touch) {
            return;
        }

        cancelTouchTimer();
        touchStart = { x: touch.clientX, y: touch.clientY };
        const $row = $(event.currentTarget);
        touchTimer = window.setTimeout(function () {
            suppressClickUntil = Date.now() + 900;
            openMenu($row, touchStart.x, touchStart.y);
            if (navigator.vibrate) {
                navigator.vibrate(20);
            }
            cancelTouchTimer();
        }, 550);
    });

    $('body').on('touchmove', ROW_SELECTOR, function (event) {
        const touch = event.originalEvent.touches?.[0];
        if (!touch || !touchStart) {
            return;
        }
        if (Math.abs(touch.clientX - touchStart.x) > 10 || Math.abs(touch.clientY - touchStart.y) > 10) {
            cancelTouchTimer();
        }
    });

    $('body').on('touchend touchcancel', ROW_SELECTOR, cancelTouchTimer);
}

export default {
    init() {
        if (!$(MENU_SELECTOR).length || $('body').data('conversation-selection-ready')) {
            return;
        }
        $('body').data('conversation-selection-ready', true);

        $('body').on('contextmenu', ROW_SELECTOR, function (event) {
            event.preventDefault();
            openMenu($(event.currentTarget), event.clientX, event.clientY);
        });

        $('body').on('keydown', ROW_SELECTOR, function (event) {
            if (event.key !== 'ContextMenu' && !(event.shiftKey && event.key === 'F10')) {
                return;
            }
            event.preventDefault();
            const bounds = event.currentTarget.getBoundingClientRect();
            openMenu($(event.currentTarget), bounds.left + 18, bounds.top + 18);
        });

        document.addEventListener('click', function (event) {
            const row = event.target.closest(ROW_SELECTOR);
            if (!row) {
                return;
            }
            if (Date.now() < suppressClickUntil) {
                event.preventDefault();
                event.stopImmediatePropagation();
                return;
            }
            if (!selected.size) {
                return;
            }
            event.preventDefault();
            event.stopImmediatePropagation();
            toggleRow($(row));
            hideMenu();
        }, true);

        $('body').on('click', '.js-conversation-context-select', function () {
            if (contextRow) {
                toggleRow(contextRow);
            }
            hideMenu();
        });

        $('body').on('click', '.js-conversation-context-read', function () {
            const descriptors = contextDescriptors();
            hideMenu();
            runAction('read', descriptors);
        });

        $('body').on('click', '.js-conversation-context-spam', function () {
            const descriptors = contextDescriptors();
            hideMenu();
            runAction('spam', descriptors);
        });

        $('body').on('click', '.js-conversation-context-delete', function () {
            const descriptors = contextDescriptors();
            hideMenu();
            openDeleteModal(descriptors);
        });

        $('body').on('click', BAR_SELECTOR + ' [data-conversation-action]', function () {
            const action = $(this).data('conversation-action');
            const descriptors = selectedDescriptors();
            if (action === 'delete') {
                openDeleteModal(descriptors);
                return;
            }
            runAction(action, descriptors);
        });

        $('body').on('click', '.js-clear-conversation-selection', clearSelection);
        $('body').on('click', DELETE_MODAL_SELECTOR + ' .js-confirm-conversation-delete', function () {
            runAction('delete', pendingDelete);
        });
        $('body').on('hidden.bs.modal', DELETE_MODAL_SELECTOR, function () {
            pendingDelete = [];
            setBusy(false);
            resetDeleteFeedback();
            renderSelection();
        });

        $('body').on('click', function (event) {
            if (!$(event.target).closest(MENU_SELECTOR).length) {
                hideMenu();
            }
        });
        $('body').on('keydown', function (event) {
            if (event.key === 'Escape') {
                hideMenu();
            }
        });
        $(window).on('resize scroll', hideMenu);

        bindTouchMenu();
        renderSelection();
    },
};
